import gql from 'graphql-tag';

export const DeleteDispatchIssueCausedBy = gql`
  mutation DeleteDispatchIssueCausedByBulk($input: DeleteDispatchIssueCausedByBulkInput!) {
    deleteDispatchIssueCausedByBulk(input: $input) {
      deleted
    }
  }
`;
